import {
  fetchAdvisorAttestationTaskDetails, completeAdvisorAttestation, cancelAdvisorAttestation, initiateAdvisorAttestation,
} from '@/lib/api';

export default {
  state: {
    attestationDetails: {},
    loading: true,
  },

  getters: {
    isLoadingAttestationDetails(state) {
      return state.loading;
    },
    attestationDetails(state) {
      return state.attestationDetails;
    },
  },

  mutations: {
    setLoadingAttestationDetails(state, loading) {
      state.loading = loading;
    },
    updateAttestationDetails(state, attestationDetails) {
      state.attestationDetails = attestationDetails;
    },
  },

  actions: {
    async fetchAdvisorAttestationTaskDetails({ commit }) {
      commit('setLoadingAttestationDetails', true);
      const attestationDetails = await fetchAdvisorAttestationTaskDetails.execute();
      commit('updateAttestationDetails', attestationDetails);
      commit('setLoadingAttestationDetails', false);

      return attestationDetails;
    },
    async completeAdvisorAttestation({ commit }, attestation) {
      commit('setLoadingAttestationDetails', true);
      await completeAdvisorAttestation.execute(attestation);
      commit('setLoadingAttestationDetails', false);

      return true;
    },
    async initiateAdvisorAttestation({ commit }) {
      commit('setLoadingAttestationDetails', true);
      await initiateAdvisorAttestation.execute();
      commit('setLoadingAttestationDetails', false);

      return true;
    },
    async cancelAdvisorAttestation({ commit }) {
      commit('setLoadingAttestationDetails', true);
      await cancelAdvisorAttestation.execute();
      commit('setLoadingAttestationDetails', false);
      return true;
    },
  },
};
